/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_Workout_FasterInputs */

const en_us2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I make it quicker today?`)
};

const pt_br2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá pra fazer mais rápido hoje?`)
};

const es_419_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo hacerlo más rápido hoy?`)
};

const pt_pt2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá para fazer mais rápido hoje?`)
};

const fr_fr2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On peut faire plus court aujourd'hui ?`)
};

const de_de2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht es heute schneller?`)
};

const it_it2_coach_suggest_workout_faster = /** @type {(inputs: Coach_Suggest_Workout_FasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso fare più in fretta oggi?`)
};

/**
* | output |
* | --- |
* | "Can I make it quicker today?" |
*
* @param {Coach_Suggest_Workout_FasterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_workout_faster = /** @type {((inputs?: Coach_Suggest_Workout_FasterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_Workout_FasterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_workout_faster(inputs)
	if (locale === "es-419") return es_419_coach_suggest_workout_faster(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_workout_faster(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_workout_faster(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_workout_faster(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_workout_faster(inputs)
	return en_us2_coach_suggest_workout_faster(inputs)
});
export { coach_suggest_workout_faster as "coach.suggest_workout_faster" }